import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '../IconButton';
import Icon from '../Icon';
import useTheme from '../../hooks/useTheme';
import { StyledTags, StyledTagsWrapper, StyledTagWrapper, StyledTag } from './styled';
import { makeStyles } from '../../utils/styles';

const useStyles = makeStyles(css => ({
    iconButton: css`
        padding: 15px;
    `
}));

const Tags = ({ tags, readonly, customStyle, onClickDelete }) => {
    const theme = useTheme();
    const styles = useStyles();
    const handleClickDelete = tag => () => onClickDelete(tag);

    return (
        <StyledTags
            customStyle={customStyle}
        >
            <StyledTagsWrapper>
                {
                    tags && tags.map((tag, index) => (
                        <StyledTagWrapper
                            key={tag?.id || index}
                            readonly={readonly}
                        >
                            <StyledTag>
                                {tag.name || tag}
                            </StyledTag>
                            {
                                !readonly &&
                                <IconButton
                                    customStyle={styles.iconButton}
                                    onClick={handleClickDelete(tag)}
                                >
                                    <Icon name="delete" width={10} height={10} fill={theme.colors.white} />
                                </IconButton>
                            }
                        </StyledTagWrapper>
                    ))
                }
            </StyledTagsWrapper>
        </StyledTags>
    );
};

Tags.propTypes = {
    tags: PropTypes.array,
    readonly: PropTypes.bool,
    customStyle: PropTypes.array,
    onClickDelete: PropTypes.func
};

Tags.defaultProps = {
    tags: [],
    readonly: false,
    onClickDelete: undefined
};

export default React.memo(Tags);
